"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("../../../util/utils");
var GanttChartProjectHover = function (_a) {
    var infoBoxRef = _a.infoBoxRef, project = _a.project;
    var projectEnd = utils_1.getProjectEnd(project);
    return (react_1.default.createElement("div", { className: 'gantt-chart-project__hover flex flex-row', ref: infoBoxRef },
        react_1.default.createElement("div", { className: 'img' }, project.client &&
            project.client.clientImage ?
            react_1.default.createElement("img", { src: project.client.clientImage.filename, alt: project.client.clientName }) :
            react_1.default.createElement("span", null, project.client && project.client.clientName.substr(0, 1))),
        react_1.default.createElement("ul", null,
            react_1.default.createElement("li", { className: 'project-name' }, project.projectName),
            react_1.default.createElement("li", { className: 'project-client' }, project.client ?
                "Client: " + project.client.clientName
                :
                    'No Client'),
            react_1.default.createElement("li", { className: 'project-tasks' },
                "Tasks: ",
                project.projectTasks.length),
            react_1.default.createElement("li", { className: 'project-deadline' },
                project.endDate ? 'Deadline:' : 'Estimated End:',
                " ",
                projectEnd.format('DD/MM/YYYY')))));
};
exports.default = GanttChartProjectHover;
